import {styled} from '@esgi/ui/theme';
import {Box} from '../../../box';

export const Div = styled(Box, {
	position: 'relative',
	width: '100%',
	height: '100%',
});
